import BottomOrDialog from 'app/components/BottomOrDialog/BottomOrDialog';
import { Box, Button, IconButton, TextField, Typography } from '@mui/material';
import VSpace from 'app/components/VSpace';
import { CloseRounded } from '@mui/icons-material';
import { useEffect, useRef, useState } from 'react';
import d from 'dompurify';

const PopupInput = ({
  open,
  onClose,
  onValue,
  title,
  description,
  cta,
}: {
  open: boolean;
  onClose: () => void;
  onValue: (value: string) => void;
  title: string;
  description: string;
  cta: string;
}) => {
  const [value, setValue] = useState('');
  const editorRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        if (editorRef.current) {
          editorRef.current.focus();
        }
      }, 100);
    }
  }, [open, editorRef]);

  return (
    <BottomOrDialog open={open} onClose={onClose}>
      <Box
        sx={{
          width: '100vw',
          maxWidth: '430px',
          padding: '24px',
          justifyContent: 'space-between',
        }}
      >
        <Box>
          <Box sx={{ position: 'absolute', top: '12px', right: '12px' }}>
            <IconButton onClick={onClose}>
              <CloseRounded />
            </IconButton>
          </Box>

          <Typography variant="h6">{title} </Typography>
          <VSpace size={1} />
          <Typography
            color="textSecondary"
            dangerouslySetInnerHTML={{
              __html: d.sanitize(description),
            }}
          />
          <VSpace size={1} />
        </Box>

        <TextField
          type="text"
          fullWidth
          value={value}
          onChange={e => setValue(e.target.value)}
          inputRef={editorRef}
        />
        <VSpace size={2} />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            onClick={() => {
              onValue?.(value);
              onClose();
              setValue('');
            }}
          >
            {cta}
          </Button>
        </Box>
      </Box>
    </BottomOrDialog>
  );
};

export default PopupInput;
